import Work1 from "../../assets/weather.png";
import Work2 from "../../assets/notes.png";
import Work3 from "../../assets/calculator.png";
import Work4 from "../../assets/news.png";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Weather",
    category: "web",
    link: "https://silver-queijadas-353e78.netlify.app/",
    code: "https://github.com/Abhishekjha36/Weather",
  },
  {
    id: 2,
    image: Work2,
    title: "Notes",
    category: "app",
    link: "https://capable-elf-9103fb.netlify.app/",
    code: "https://github.com/Abhishekjha36/Notes-App",
  },
  {
    id: 3,
    image: Work3,
    title: "Calculater",
    category: "design",
    link: "https://dynamic-stroopwafel-1efed1.netlify.app/",
    code: "https://github.com/Abhishekjha36/Calculator-",
  },
  {
    id: 4,
    image: Work4,
    title: "News",
    category: "app",
    code: "https://github.com/Abhishekjha36/News-App",
  },
];
